import WorkflowContext from 'contexts/workflow/context';
import { useContext } from 'react';

export const useWorkflow = () => useContext(WorkflowContext);
